/* 🤖 this file was generated by svg-to-ts*/
export const icoFolderOpen: {
  name: 'folder-open';
  data: string;
} = {
  name: 'folder-open',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 3a1 1 0 01.482.124l.106.067L11 5h6a2 2 0 011.994 1.85L19 7v4h2a1 1 0 01.97 1.242l-.034.11-2.756 7.35a2 2 0 01-1.707 1.291l-.166.007H4a2 2 0 01-1.995-1.85L2 19V5a2 2 0 011.85-1.995L4 3h4zm11.556 10H6.693l-2.25 6h12.864l2.249-6zM17 7H4v7.483l1.064-2.834a1 1 0 01.812-.641L6 11h11V7z" fill="#909090"/></svg>`
};
